import type { AuthSession } from './api'

const key = 'storeops.web.session.v1'

export function loadSession(): AuthSession | null {
  try {
    const raw = window.sessionStorage.getItem(key)
    return raw ? JSON.parse(raw) as AuthSession : null
  } catch {
    return null
  }
}

export function saveSession(session: AuthSession | null) {
  if (session) window.sessionStorage.setItem(key, JSON.stringify(session))
  else window.sessionStorage.removeItem(key)
}
